export class CashMovementDto {
  valueDate: Date;
  displayName: string;
  currencyCode: string;
  sumAmount: number;
  eventAudit: string | undefined;

  sumTradeMatured: number;
  sumExchangeFee: number;
  source: string;
  accountId: number | undefined;
  postingTypeId: number;

  constructor(valueDate: any, displayName: string, currencyCode: string, sumAmount: number, eventAudit: string | undefined, postingTypeId: number, source: string, accountId?: number) {
    this.valueDate = valueDate;
    this.displayName = displayName;
    this.currencyCode = currencyCode;
    this.sumAmount = sumAmount;
    this.eventAudit = eventAudit;

    this.sumTradeMatured = 0;
    this.sumExchangeFee = 0;
    this.postingTypeId = postingTypeId;
    this.source = source;
    this.accountId = accountId;
  }
}
